import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import classnames from 'classnames';
import useApiClient from '../../../hooks/api/useApiClient';
import { useGetManagersQuery } from '../../../store/api-slices';

export default function ManagerSelect({
  value,
  onLoad,
  onChange,
  formatOptions,
  roles = null,
  isMulti = false,
  className,
  status = null,
  ...rest
}) {
  const { ManagersManager } = useApiClient();

  const { data, isLoading } = useGetManagersQuery({
    apiManager: ManagersManager,
    roles,
    ...(status !== null && { status }),
  });
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    if (data && data.length > 0) {
      onLoad ? onLoad({ data, setManagers }) : setManagers(data);
    }
  }, [data]);

  const options = useMemo(
    () => (formatOptions ? formatOptions(managers) : managers.map((item) => ({ value: item.id, label: item.name }))),
    [managers],
  );

  return (
    <Select
      value={value}
      loading={isLoading}
      options={options}
      mode={isMulti ? 'multiple' : undefined}
      showSearch={{ optionFilterProp: 'label' }}
      onChange={(value) => onChange(value)}
      className={classnames('min-w-[250px]', className)}
      {...rest}
    />
  );
}
